import { SN, zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'
import { Abono } from './abono'
import { Afastamento } from './afastamentos'
import { LogCalculos } from './calculo'
import { FaltaInjustificada, FaltaJustificada } from './faltas-cadastradas'
import { CompensacaoDia } from './feriados'
import { Funcionario } from './funcionario'
import { Ocorrencia } from './ocorrencia'
import { Sobreaviso } from './sobreaviso'

interface PorcentagemHrsExtras {
    [keys: string]: number
}

export type EspelhoPonto = z.infer<typeof zod.EspelhoPontoSchema> & {
    porcentagemHrsExtras: PorcentagemHrsExtras
    porcentagemHrsExtrasNoturnas: PorcentagemHrsExtras
    Abono?: Abono
    Afastamento?: Afastamento & { Ocorrencia?: Ocorrencia }
    CompensacaoDia?: CompensacaoDia
    Sobreaviso?: Sobreaviso
    DescontoDSR?: unknown // Todo: Criar schema
    DSR?: unknown
    FaltaCadastrada?: FaltaJustificada | FaltaInjustificada
}

export type CalculoEspelho = z.infer<typeof zod.CalculoSchema> & {
    EspelhoPonto: EspelhoPonto[]
    porcentagemHrsExtras: PorcentagemHrsExtras
    porcentagemHrsExtrasNoturnas: PorcentagemHrsExtras
    Funcionario: Funcionario
    saldoAtual: string | null
    saldoAnterior: string | null
    PagamentoHoras?: z.infer<typeof zod.PagamentoHorasSchema>
    LogCalculos: LogCalculos[]
    totHrsATrabalhar: string
    totHrsTrabalhadas: string
    totAdicNoturno: string
    totDescontoDSR?: string | number
    totalFaltasJustificadas: string
    totalFaltasInjustificadas: string
}

export type EspelhoAceite = {
    id: number | string
    competencia: string
    empresaId: number
    funcionarioId: number
    Funcionario: Funcionario
    aceito: SN
    dataAceite: Date
    motivo?: string
    atual?: boolean
    matricula: number
}

type QueryParams = {
    competencia: string
    empresaId: number
    centroCustoId?: number
    locaisIds?: number[]
}

export type EditarDiaEspelhoInput = {
    competencia: string
    /** Dia no formato YYYY-MM-DD */
    data: string
    horasTrabalhadas: string
    faltas: string
    /** Horas extras por porcentagem da regra de cálculo: { '50': '01:00' } */
    horasExtras: Record<string, string>
    justificativa: string
}

const service = new ApiService<CalculoEspelho, CalculoEspelho, QueryParams>(
    'espelho-ponto',
)

export const espelhoPonto = Object.assign(service, {
    aceite: new ApiService<CalculoEspelho>('espelho-ponto/aceite'),
    relatorioAceite: new ApiService<EspelhoAceite>(
        'espelho-ponto/relatorio-aceite',
    ),
    historicoAceite: new ApiService<EspelhoAceite>(
        'espelho-ponto/relatorio-aceite/historico',
    ),
    calculos: new ApiService<CalculoEspelho>('espelho-ponto/calculos'),
    // PATCH espelho-ponto/:funcionarioId/dias
    editarDia: (funcionarioId: number, input: EditarDiaEspelhoInput) =>
        service.patch<EspelhoPonto>(
            String(funcionarioId),
            'dias',
            input as never,
        ),
    // PATCH espelho-ponto/:funcionarioId/dias/reverter
    excluirEdicaoDia: (
        funcionarioId: number,
        input: { competencia: string; data: string },
    ) =>
        service.patch<EspelhoPonto>(
            String(funcionarioId),
            'dias/reverter',
            input as never,
        ),
})
